import { ShowIf } from '@apply/components';
import { PropertyType } from './components/PropertyType';
import { TwoToFourUnitStructure } from './components/TwoToFourUnitStructureType';
import { Units } from './components/Units';
import { CommercialExperienceCheckButton } from './components/CommercialExperienceCheckButton';
import { useExperiencePropertyTypeId } from '../../../fields/ExperienceFields';
import { ExperiencePropertyType } from '@apply/constants';

interface PropertyTypeInformationProps {
    experienceId: string | undefined;
    readOnly?: boolean;
}

export const PropertyTypeInformation: React.FC<PropertyTypeInformationProps> = ({ experienceId, readOnly = false }) => {
    const [propertyType] = useExperiencePropertyTypeId(experienceId);

    const showTwoToFour = propertyType === ExperiencePropertyType.TwoToFourUnitStructure;

    const showUnits = [ExperiencePropertyType.FivePlusMultifamily, ExperiencePropertyType.ResidentialMixedUse].includes(
        propertyType!
    );

    const showCommercialConfirmation = propertyType === ExperiencePropertyType.Commercial;

    const minimumUnits = propertyType === ExperiencePropertyType.FivePlusMultifamily ? 5 : 0;

    return (
        <>
            <PropertyType
                experienceId={experienceId}
                required={false}
                readOnly={readOnly}
            />
            <ShowIf showIf={showTwoToFour}>
                <TwoToFourUnitStructure
                    experienceId={experienceId}
                    required={showTwoToFour}
                    readOnly={readOnly}
                />
            </ShowIf>
            <ShowIf showIf={showUnits}>
                <Units
                    experienceId={experienceId}
                    required={showUnits}
                    minimumUnits={minimumUnits}
                />
            </ShowIf>
            <ShowIf showIf={showCommercialConfirmation}>
                <CommercialExperienceCheckButton
                    experienceId={experienceId}
                    readOnly={readOnly}
                />
            </ShowIf>
        </>
    );
};
